export default {
  /**
  * @method normal
  */
  normal(title, data) {
    if (title && process.env.NODE_ENV === 'development') {
      if (typeof data === 'object') {
        console.log(title)
        if (data || data >= 0) {
          console.log(data)
        }
      } else {
        console.log(title + ' ' + data)
      }
    }
  }
}
